import EStyleSheet from 'react-native-extended-stylesheet';

const styles = EStyleSheet.create({
	heading: {
		paddingTop: '2rem',
		paddingHorizontal: '1rem',
	},
	scrollInner: {
		flexGrow: 1,
	},
});

export default styles;
